import React from "react";
import Skeletons from "./Skeletons";
import { DEVICE_SIZES, useDeviceSize } from "rn-responsive-styles";
import { View } from "react-native";
import { AppColors } from "../../utility/AppColors";

const GameShowDetailSkeleton = () => {
  const deviceSize = useDeviceSize();
  let skeletonCards = Array(5).fill(0);
  const isMobile =
    deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS;

  return (
    <View
      style={{
        justifyContent: "center",
        flexDirection: isMobile ? "column" : "row",
        gap: isMobile ? 12 : 10,
        marginTop: isMobile ? 12 : 0,
      }}
    >
      <View
        style={{
          justifyContent: "center",
          width: isMobile ? "100%" : "auto",
          alignItems: isMobile ? "center" : "flex-start",
        }}
      >
        <Skeletons
          height={isMobile ? 180 : 218}
          width={isMobile ? "100%" : "241px"}
          style={{ borderRadius: 8, marginBottom: isMobile ? 0 : 26 }}
          backgroundColor={AppColors.gray_C4C4C4}
        />
      </View>
      <View
        style={{
          gap: 12,
          justifyContent: "center",
          flexDirection: isMobile ? "row" : "column",
          flexWrap: isMobile ? "wrap" : "nowrap",
          paddingTop: isMobile ? 8 : 0,
        }}
      >
        {[...Array(4)].map((_, index) => (
          <View
            key={index}
            style={{
              width: isMobile ? "47%" : "auto",
            }}
          >
            <Skeletons
              height={isMobile ? 12 : 16}
              width={isMobile ? "80%" : "80px"}
              style={{
                borderRadius: 6,
                marginVertical: isMobile ? 5 : 10,
              }}
              backgroundColor={AppColors.gray_C4C4C4}
            />
            <Skeletons
              height={isMobile ? 12 : 16}
              width={
                isMobile
                  ? "90%"
                  : index === 2
                  ? "100px"
                  : "120px"
              }
              style={{ borderRadius: 6 }}
              backgroundColor={AppColors.gray_C4C4C4}
            />
          </View>
        ))}
      </View>
    </View>
  );
};

export default GameShowDetailSkeleton;
